import { podoFetcher } from '@server/infrastructure/external-apis/podo/client'
import { BaseResponseSchema } from '@server/schemas'
import { toCamelCase } from '@server/shared/utils/case-adapter'

import { getBearerToken } from '../../authentication'

export interface ExtendBenefitCouponDto {
  couponId: string
  templateId: number
  displayStatus: string
  title: string
  discountType: string
  discountAmount: number
  discountAmountMax: number
  discountApplicationType?: 'RECURRING' | 'LIMITED'
  discountedPaymentCount?: number
  utcUseStart: string
  utcUseEnd: string
  utcDisplayUsedAt: string
  utcCreatedAt: string
  description: string
  paymentTypes: string[]
  templateType: string
}

export interface ExtendBenefitDto {
  eligible: boolean
  benefitType: string | null
  bonusDays: number
  bonusCount: number
  finalDate: string | null
  coupon: ExtendBenefitCouponDto | null
}

export const getExtendBenefit = async (subscribeId: string, bearerToken?: string) => {
  const authorizationToken = bearerToken ?? (await getBearerToken())

  const response = await podoFetcher<BaseResponseSchema<ExtendBenefitDto>>({
    url: `/api/v2/subscribe/podo/extend/benefit?subscribeId=${subscribeId}`,
    method: 'GET',
    header: {
      Authorization: `Bearer ${authorizationToken}`,
    },
  })

  return { ...response, data: toCamelCase<ExtendBenefitDto>(response.data) }
}
